<template>
  <div class="space-rocket" :style="style">
    <div class="rocket-hover">
      <svg width="40" height="56" viewBox="0 0 40 56" fill="none" class="drop-shadow-lg">
        <!-- Flame -->
        <ellipse cx="20" cy="52" rx="5" ry="6" fill="#f97316" opacity="0.8" class="flame-flicker" />
        <ellipse cx="20" cy="50" rx="3" ry="4" fill="#fbbf24" opacity="0.9" class="flame-flicker-inner" />
        <!-- Rocket body -->
        <path d="M14,42 L14,20 Q14,8 20,2 Q26,8 26,20 L26,42 Z" fill="#e2e8f0" />
        <!-- Rocket nose -->
        <path d="M17,18 Q17,10 20,4 Q23,10 23,18 Z" fill="#ef4444" />
        <!-- Window -->
        <circle cx="20" cy="26" r="4" fill="#38bdf8" />
        <circle cx="19" cy="25" r="1.5" fill="white" opacity="0.5" />
        <!-- Fins -->
        <path d="M14,36 L8,44 L14,42 Z" fill="#ef4444" />
        <path d="M26,36 L32,44 L26,42 Z" fill="#ef4444" />
        <!-- Body stripe -->
        <rect x="14" y="34" width="12" height="2" fill="#94a3b8" rx="1" />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  x: { type: Number, required: true },
  y: { type: Number, required: true }
});

const style = computed(() => ({
  position: 'absolute',
  left: `${props.x - 20}px`,
  top: `${props.y - 60}px`,
  transition: 'left 0.6s ease, top 0.6s ease',
  zIndex: 20,
  pointerEvents: 'none'
}));
</script>

<style scoped>
.rocket-hover {
  animation: rocket-float 2s ease-in-out infinite;
}

@keyframes rocket-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

.flame-flicker {
  animation: flame 0.3s ease-in-out infinite alternate;
}

.flame-flicker-inner {
  animation: flame 0.2s ease-in-out infinite alternate;
}

@keyframes flame {
  0% { opacity: 0.6; transform: scaleY(0.9); }
  100% { opacity: 1; transform: scaleY(1.1); }
}
</style>
